import React , {useState , useEffect} from 'react';
import { Link } from 'react-router-dom';
import { getDocs , collection , db  } from '../firebase';
import './ExperincesSection.css';


const ExperincesSection = () => {

  const [ experinceArray , setExperincesArray ] = useState([]);

  useEffect(  () => {

    const getExperincesData = async () => { 
      const querySnapshot = await getDocs(collection(db, "experiences"));
      const experincesdataarray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setExperincesArray(experincesdataarray);
     
    }
    getExperincesData();
  } , []);

  return (
    <div>

        <div className="mt-4"></div>

      <div className="grid_places">

      {experinceArray && experinceArray.map(( { id , experince_name  , experince_photos , experince_price , experince_location } ) => (

        <div className="single_experince_div" data-aos="fade-up-right" data-aos-delay="20" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250"  >

        <Link to={`/experinces/${id}`}>
        <img src={experince_photos[0]}  alt="" className="experince_img" />
        </Link>
   

    <div className=" body_experince_card">
    <p className="location_experince_sm mt-1-small"> {experince_location} </p>

    <h1 className="location_headline"> { experince_name }</h1>

    <p className="experince_price mt-1"> سعر يبدأ من   <br /> <span className="span_bold">{experince_price} ريال </span> </p>
    
    <Link to={`/experinces/${id}`}>
    <div className="d-flex-c f-sp">
   
    <button className="btn_category ">  احجز الان </button>
   
    <img src="/images/icons/left-arrow-purple.png" alt="" className="icon_experince" />
    </div>
    </Link>

    </div>

    </div>

      )) }

      </div>








    </div>
  )
}

export default ExperincesSection